import React from 'react';
import { useLocation } from "react-router-dom";
import { Link } from 'react-router-dom';
import routes from "routes.js";

const findRouteByPath = (routes, path, ancestors = []) => {
  for (let route of routes) {
    if ((route.layout + "/" + route.path) === path) {
      return { route, ancestors };
    }
    if (route.children) {
      const result = findRouteByPath(route.children, path, [...ancestors, route]);
      if (result) {
        return result;
      }
    }
  }
  return null;
};

const generateBreadcrumbs = (path) => {
  const pathSegments = path.split('/').filter(segment => segment);
  let breadcrumbs = [];
  let accumulatedPath = '';
  let dynamicPaths = [];

  pathSegments.forEach((segment, index) => {
	if (isNaN(segment) === false) {
		let previous = pathSegments[index-1];
		if(previous){
			const previousSplit = previous.split('-');
			const dynamicParam = previousSplit[previousSplit.length - 1];
			const variableSegment = `:${dynamicParam.substring(0, dynamicParam.length - 1)}Id`;
			
			accumulatedPath += `/${variableSegment}`;			
			dynamicPaths.push({variable: variableSegment, value: segment});
		}else{
			accumulatedPath += `/${segment}`;
		}		
	}else{
		accumulatedPath += `/${segment}`;	
	}
    
    const { route, ancestors } = findRouteByPath(routes, accumulatedPath) || {};
    if (route) {
      breadcrumbs = [...ancestors, route];
    }
  });
  
  // map breadcrumbs dynamic path with the actual value 
  breadcrumbs = breadcrumbs.map(route =>{  	
  	let actualPath = route.path;
  	dynamicPaths.forEach(dynamicPath => {
		actualPath = actualPath.replace(dynamicPath.variable, dynamicPath.value);		
	});
	return { ...route, path: actualPath };
  });
  
  return breadcrumbs;
};

const PanelBreadcrumbs = () => {
	const location = useLocation();	
  	const breadcrumbs = generateBreadcrumbs(location.pathname);
  	const currentRoute = breadcrumbs.length > 0 ? breadcrumbs[breadcrumbs.length-1] : null;

  	return (    
		<section className="pb-8 pt-10 text-center">
			<div className="mb-1 text-2xl text-green-700">🌿</div>
          	<div className="mx-auto flex max-w-5xl items-center justify-center gap-5">
            	<div className="h-px flex-1 bg-green-300" />
				<div>
					<h2 className="text-2xl font-bold text-green-800 capitalize">{currentRoute?.name?.toUpperCase()}</h2>
				</div>
				<div className="h-px flex-1 bg-green-300" />
			</div>

			{currentRoute?.tagline && 
			<p className="mt-4 text-md font-medium text-gray-700 md:text-base">
				{currentRoute?.tagline}
			</p>
			}
        </section>

	    // <div className="w-full max-w-[990px]">		    			        	        
	    //     <p className={`shrink capitalize text-theme-700 dark:text-white text-center ${currentRoute?.name === 'Services' ? 'text-[24px] pt-4' : 'text-[18px] pt-1'}`}>
	    //     	<Link to="#"
	    //     		className="font-bold capitalize hover:text-theme-700 dark:hover:text-white"
	    //     	>{currentRoute?.name}
	    //     	</Link>	          
	    //     </p>
	  	// </div>
  	);
};

export default PanelBreadcrumbs;